import { useAccessibility } from "@/contexts/AccessibilityContext";

/**
 * Skip-to-content link. Only renders when accessibility mode is on.
 * Visually hidden until focused via keyboard.
 */
export function SkipToContent() {
  const { enabled } = useAccessibility();
  if (!enabled) return null;
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}
